<div class="row">
    <div class="col">

        <!--
        TODO: This should have virtul scroll implemented when this issue is fixed: https://github.com/angular/components/issues/10122
                There is a work around: https://stackblitz.com/edit/angular-table-virtual-scroll-sticky-headers-xsvmgt?file=src%2Fapp%2Fapp.component.ts
                In this particular case sticky headers and footers were prioritized over virtual scrolling
        -->

        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" cdk-table [dataSource]="kronekladde" [trackBy]="trackByPid">

                <ng-container cdkColumnDef="glkundenr">
                  <th cdk-header-cell *cdkHeaderCellDef>Nr</th>
                  <td cdk-cell *cdkCellDef="let sag" [class.background--blocked]="sag.blocked">
                    <span class="clickable--link" (click)="onClient(sag.kid)">{{sag.glkundenr}}</span>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="kunde">
                  <th cdk-header-cell *cdkHeaderCellDef>Kunde</th>
                  <td cdk-cell *cdkCellDef="let sag" [class.background--blocked]="sag.blocked">
                    <span class="clickable--link" (click)="onClient(sag.kid)">{{sag.navn1}}</span>
                  </td>
                </ng-container>

                <ng-container cdkColumnDef="sag">
                  <th cdk-header-cell *cdkHeaderCellDef>Sag</th>
                  <td [class.background--blocked]="sag.faktureret" cdk-cell *cdkCellDef="let sag">
                    <span *ngIf="+sag.kid > 0" class="clickable--link" (click)="onCase(sag)">{{sag.beskrivelse}}</span>
                    <span *ngIf="+sag.kid === 0">{{sag.beskrivelse}}</span>
                  </td>
                </ng-container>

                <ng-container *ngFor="let day of [1,2,3,4,5,6,7]">
                    <ng-container [cdkColumnDef]="'krDag'+day">
                        <th cdk-header-cell *cdkHeaderCellDef>
                            <div class="text-center">
                                {{ weekHeaders[day-1] | date:'dd-MM' }}
                            </div>
                            <div class="text-center">
                                {{ weekHeaders[day-1] | date:'EEEE' }}
                            </div>
                        </th>
                        <td cdk-cell *cdkCellDef="let sag"  [class.background--highlighted]="day === today">
                            <app-money-log-td
                                [kr]="sag['krDag'+day]"
                                [beskrivelse]="sag['beskrivelseDag'+day]"
                                [disabled]="sag.faktureret || sag.blocked || ugerepDoneWeek[day - 1]"
                                [dayTotal]="weekTotals[day - 1]"
                                (saveKr)="onSaveKr($event, sag, day)"
                                (saveBeskrivelse)="onSaveBeskrivelse($event, sag, day)"
                            ></app-money-log-td>
                        </td>
                    </ng-container>
                </ng-container>

                <ng-container cdkColumnDef="ialt">
                    <th cdk-header-cell *cdkHeaderCellDef class="text-end">I alt</th>
                    <td class="text-end" cdk-cell *cdkCellDef="let sag">{{sag.krIalt | currency:'DKK':'':'1.2-2':'da'}}</td>
                </ng-container>

                <ng-container cdkColumnDef="sagskort">
                    <th cdk-header-cell *cdkHeaderCellDef class="text-center"><i class="fa fa-file-text-o"></i></th>
                    <td cdk-cell *cdkCellDef="let sag" class="text-center">
                        <span *ngIf="sag.glkundenr > 0" class="clickable--link" ngbTooltip="Sagskort" (click)="onCaseCard(sag.kid)">
                            <i class="case__icon fa fa-file-text-o"></i>
                        </span>
                    </td>
                </ng-container>

                <!-- Footer -->

                <ng-container cdkColumnDef="blank">
                    <th cdk-footer-cell *cdkFooterCellDef></th>
                </ng-container>

                <ng-container cdkColumnDef="total-text">
                    <th cdk-footer-cell *cdkFooterCellDef>I alt</th>
                </ng-container>

                <ng-container cdkColumnDef="done-text">
                    <th cdk-footer-cell *cdkFooterCellDef>Færdig</th>
                </ng-container>

                <ng-container *ngFor="let day of [0,1,2,3,4,5,6]">
                    <ng-container [cdkColumnDef]="'total-day-'+day">
                        <th cdk-footer-cell *cdkFooterCellDef class="text-end">
                            <div class="text-end sum__div">{{ weekTotals[day] | currency:'DKK':'':'1.2-2':'da' }}</div>
                            <div class="sum__div"></div>
                        </th>
                    </ng-container>
                    <ng-container [cdkColumnDef]="'done-day-'+day">
                        <th cdk-footer-cell *cdkFooterCellDef>
                            <div class="d-grid">
                                <button *ngIf="!ugerepDoneWeek[day]" type="button" class="btn btn-table btn-sm btn-success" (click)="onDoneDay(day)">Luk</button>
                            </div>
                            <div class="d-grid">
                                <button *ngIf="ugerepDoneWeek[day]" type="button" class="btn btn-table btn-sm btn-secondary" disabled>Lukket</button>
                            </div>
                        </th>
                    </ng-container>
                </ng-container>

                <ng-container cdkColumnDef="total-week-sum">
                    <th cdk-footer-cell *cdkFooterCellDef class="text-end">{{ weekTotalsSum | currency:'DKK':'':'1.2-2':'da' }}</th>
                </ng-container>

                <tr class="table__header--border" cdk-header-row *cdkHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: displayColumns"></tr>
                <tr class="table__footer--border" cdk-footer-row *cdkFooterRowDef="['blank', 'blank', 'total-text', 'total-day-0', 'total-day-1', 'total-day-2', 'total-day-3', 'total-day-4', 'total-day-5', 'total-day-6', 'total-week-sum', 'blank']; sticky: true"></tr>
                <tr cdk-footer-row *cdkFooterRowDef="['blank', 'blank', 'done-text', 'done-day-0', 'done-day-1', 'done-day-2', 'done-day-3', 'done-day-4', 'done-day-5', 'done-day-6', 'blank', 'blank']; sticky: true"></tr>

            </table>
        </div>

    </div>
</div>
